import { Reveal, Eyebrow, SectionTitle } from "./shared";

const QA = [
  {
    q: "Quem é Padre Lucas Macieira?",
    a: "Padre Lucas Macieira é ministro anglicano católico e celebrante de casamentos desde 1999, atuando em Belo Horizonte, na Região Metropolitana e em Minas Gerais, celebrando histórias de amor.",
  },
  {
    q: "Onde Padre Lucas Macieira celebra casamentos?",
    a: "Em igrejas, sítios, chácaras, fazendas, jardins, hotéis, pousadas, salões de festas e residências — em Belo Horizonte, na Região Metropolitana e em outras cidades de Minas Gerais, mediante consulta de disponibilidade.",
  },
  {
    q: "Quanto custa um celebrante de casamento em Belo Horizonte?",
    a: "Os serviços de celebrante são anunciados a partir de R$ 1.400, com faixa atualmente divulgada entre R$ 1.400 e R$ 1.600. Custos de deslocamento, pedágio, alimentação ou hospedagem, quando necessários, são apresentados como orçamento prévio.",
  },
  {
    q: "É possível realizar casamento religioso em sítio, chácara ou fazenda?",
    a: "Sim. O casamento não precisa acontecer dentro de uma igreja: a cerimônia religiosa pode ser realizada no espaço escolhido pelo casal, com a mesma espiritualidade e dignidade.",
  },
  {
    q: "Divorciados podem realizar uma nova cerimônia religiosa?",
    a: "Sim. A tradição anglicana acolhe pastoralmente pessoas divorciadas, e cada situação é conversada pessoalmente com o casal, de forma reservada, para encontrar o formato adequado de celebração.",
  },
  {
    q: "É possível realizar casamento religioso com efeito civil?",
    a: "Sim, quando os noivos realizam previamente a habilitação perante o Cartório de Registro Civil competente e cumprem as exigências legais aplicáveis. Nenhuma cerimônia possui efeito civil automático.",
  },
  {
    q: "Qual a diferença entre celebrante de casamento e padre celebrante?",
    a: "O celebrante de casamentos conduz cerimônias personalizadas em qualquer espaço adequado; o padre celebrante é um ministro ordenado de uma igreja. Padre Lucas Macieira une os dois: é ministro anglicano católico e celebrante desde 1999, o que permite cerimônias com profundidade religiosa e liberdade de personalização.",
  },
  {
    q: "Como contratar um celebrante de casamento em Belo Horizonte?",
    a: "Comece pela consulta de disponibilidade, que não gera compromisso. Depois da conversa inicial, o roteiro da cerimônia é construído com o casal até o grande dia. Fale pelo WhatsApp (31) 99305-3446.",
  },
  {
    q: "Padre Lucas Macieira realiza renovação de votos e bodas?",
    a: "Sim. Além de casamentos, ele celebra renovação de votos matrimoniais e cerimônias de bodas em Belo Horizonte, Região Metropolitana e Minas Gerais — celebrações personalizadas para reafirmar a história do casal, com investimento a partir de R$ 1.400,00.",
  },
  {
    q: "O que é uma cerimônia de casamento ecumênica?",
    a: "É uma celebração que acolhe casais de diferentes tradições religiosas, respeitando a fé de cada um. Padre Lucas Macieira constrói o roteiro junto ao casal, com espiritualidade cristã e linguagem que abrace as duas famílias.",
  },
];

export default function EditorialQA() {
  return (
    <section className="py-20 lg:py-28 bg-warmwhite" data-testid="editorial-qa-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <Reveal>
          <div className="text-center">
            <Eyebrow>Respostas diretas</Eyebrow>
            <SectionTitle>Perguntas que os noivos fazem</SectionTitle>
            <p className="mt-4 text-base font-light text-cocoa max-w-2xl mx-auto leading-relaxed">
              Respostas objetivas às dúvidas mais comuns de quem está começando a planejar a cerimônia.
            </p>
          </div>
        </Reveal>
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-8">
          {QA.map((item, i) => (
            <Reveal key={i} delay={(i % 2) * 0.08}>
              <div data-testid={`editorial-qa-${i}`}>
                <h3 className="font-serif text-xl text-ink leading-snug">{item.q}</h3>
                <p className="mt-2 text-sm sm:text-base font-light text-cocoa leading-relaxed">{item.a}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
